module.exports = __webpack_public_path__ + "img/login-view.35e25cfa.png";